import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import classes from './clientlist.scss';
import { Link } from 'react-router-dom';
import resolveRoute from 'lib/resolve-route';
import GetStarted from 'components/get-started-view';
import st from 'core/shared-translations';
import {
  Typography ,
  Button ,
  CircularProgress } from '@getgo/chameleon-web-react-wrapper';
import { AddOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Box } from '@mui/system';
import TableContainer from '../containers/table-container';
import ClientSearchBarView from './client-search-bar-view';

const t = defineMessages({
  'client-info.createAnotherClient': {
    id: 'client-info.createAnotherClient',
    defaultMessage: 'Add client',
    description: 'Label for the add client CTA area',
  },
  'client-info.subtitle': {
    id: 'client-info.subtitle',
    defaultMessage: 'Manage clients and secrets',
    description: 'Subtitle for client list view'
  },
  'client-info.info-text': {
    id: 'client-info.info-text',
    defaultMessage: 'Use clients and secrets to access GoTo resources for your development projects. Secrets let you authenticate securely with GoTo APIs.',
    description: 'Info text for client list view'
  },
});

const ClientList = ({
  clientList,
  hasClients,
  isLoading,
  showClientIdSearchInput,
  onChange,
  searchValue,
  onSearch,
  error,
  clientExist,
  ctaClicked,
  searchLoading
}) => {
  const intl = useIntl();
  return (
    <Box>
      {isLoading &&
        <CircularProgress id="loadingDiv" className={classes["loading"]} />}
      {!isLoading &&
        <Box id="client-list-section">
          <Box className={classes['listViewHeading']}>
            <Typography variant="heading-large">
              <FormattedMessage {...st['shared.oauthclients']} />
            </Typography>
            {hasClients && <Box className={classes['addClientCTA']}>
              <Link to={resolveRoute('clients.clientcreate')}>
                <Button
                  title="createToken"
                  className={classes["createTokenCta"]}
                  leadingIcon={<AddOutlinedIcon />}
                >
                  <FormattedMessage {...t["client-info.createAnotherClient"]} />
                </Button>
              </Link>
            </Box>}
          </Box>
          <Box className={classes["mainContentClientView"]}>
            <Box className={classes["spaceBetweenContent"]}>
              {hasClients && !isLoading &&  <React.Fragment>
                <Box className={classes["infoText"]}>
                  <Typography variant="heading-small">
                    <FormattedMessage
                      {...t["client-info.subtitle"]}
                  />
                  </Typography>
                  <Typography variant="body-medium">
                    <FormattedMessage {...t["client-info.info-text"]} />
                  </Typography>
                </Box>
              </React.Fragment>}
            </Box>
            {!hasClients && !isLoading &&
              <Box>
                <Box className="col-xs-12 col-sm-6">
                  <Box className={classes['getStarted']}>
                    <GetStarted
                      onChange={onChange}
                      searchValue={searchValue}
                      error={error}
                      onSearch={onSearch}
                      ctaClicked={ctaClicked}
                      clientExist={clientExist}
                      searchLoading={searchLoading}
                      showClientIdSearchInput={showClientIdSearchInput}
                      />
                  </Box>
                </Box>
              </Box>}
            {hasClients && !!clientList.length && <Box className={classes["flexSideSmall"]}>
              {showClientIdSearchInput && <Box className="col-xs-12 col-sm-6">
                <ClientSearchBarView
                  onChange={onChange}
                  searchValue={searchValue}
                  error={error}
                  onSearch={onSearch}
                  />
              </Box>}
              <TableContainer clientList={clientList} />
            </Box>}
          </Box>
        </Box>}
    </Box>);
};

ClientList.propTypes = {
  clientList: PropTypes.array.isRequired,
  hasClients: PropTypes.bool.isRequired,
  isOneColumnLayout: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showClientIdSearchInput: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
  clientExist: PropTypes.bool.isRequired,
  ctaClicked: PropTypes.bool.isRequired,
  searchLoading: PropTypes.bool.isRequired,
};

export default ClientList;


